// Toasts flotantes: se muestran por defecto (sin depender de JS) y el JS solo
// se encarga de la SALIDA — tras unos segundos se desvanecen y se eliminan.
// La entrada la anima CSS (@keyframes toast-in en application.css).

export function initToasts() {
  document.querySelectorAll("[data-toast-item]").forEach((el, i) => {
    el.style.transition = "opacity .3s ease, transform .3s ease"
    setTimeout(() => {
      el.style.opacity = "0"
      el.style.transform = "translateX(1rem)"
      setTimeout(() => el.remove(), 300)
    }, 4000 + i * 400)
  })
}
